import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tgss-notifications2',
  templateUrl: './tgss-notifications2.component.html',
  // styleUrls: ['./tgss-notifications2.component.scss']
})
export class TgssNotifications2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
